module.exports = __webpack_public_path__ + "img/something_broken.27977ca2.png";